import { isDarkColor } from "@/utils/color";
import { createWidget, destoryWidget } from "@/utils/widget";
import classNames from "classnames";
import { useEffect } from "react";
import { ButtonCreatorConfig } from "../sections/Section27/utils";

export type WidgetProps = ButtonCreatorConfig &
  React.HTMLAttributes<HTMLDivElement> & {
    overlay?: boolean;
  };

const Widget = ({
  backgroundType,
  buttonColor,
  buttonLabel,
  compareType,
  crop,
  designType,
  id,
  overlay = true,
  threshold,
  url,
  ...props
}: WidgetProps) => {
  useEffect(() => {
    if (designType === "link-only") {
      return;
    }

    createWidget({
      widgetId: id,
    });

    return () => {
      destoryWidget({
        widgetId: id,
      });
    };
  });

  const buttonTextColor = isDarkColor(buttonColor) ? "#ffffff" : "#111111";

  return (
    <div className="relative">
      {designType === "link-only" ? (
        <a
          href=""
          style={{
            fontWeight: "bold",
            textDecoration: "underline",
            color: buttonColor,
          }}
        >
          {buttonLabel}
        </a>
      ) : (
        <div
          data-bg={backgroundType}
          data-btn={`${buttonColor}, ${buttonTextColor}`}
          data-compare={compareType}
          data-crop={crop}
          data-label={buttonLabel}
          data-mode={designType}
          data-trigger={threshold}
          id={id}
          {...props}
        />
      )}
      {overlay && <div className={classNames("absolute left-0 top-0 h-full w-full opacity-0")} id={`${id}-overlay`} />}
    </div>
  );
};

Widget.displayName = Widget.name;

export default Widget;
